import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  wrapper: {},
  area: {},
});

export default useStyles;
